import Promise from 'promise';

class ImageUtils {
	canvas = '';

	file = '';

	getBase64(mime_type) {
		let that = this;

		return new Promise((resolve, reject) => {
			resolve(that.canvas.toDataURL(mime_type));
		}).catch((e) => {
			throw e;
		});
	}

	read(file) {
		let that = this;

		let url = file.url;

		return new Promise(function (resolve, reject) {
			if (url.match(/^http/) || url.match(/^data/) || url.match(/^\//)) {
				that.urlToCanvas(url).then((image) => {
					resolve(that);
				});
			} else {
				let reader = new FileReader();
				reader.onload = (e) => {
					that.urlToCanvas(e.target.result).then((image) => {
						resolve(that);
					});
				};

				reader.readAsDataURL(file);
			}
		}).catch((e) => {
			throw e;
		});
	}

	urlToCanvas(url) {
		let that = this;

		return new Promise(function (resolve, reject) {
			let img = new Image();

			img.setAttribute('crossOrigin', 'anonymous');

			img.onload = () => {
				let canvas = document.createElement('canvas');
				canvas.width = img.naturalWidth;
				canvas.height = img.naturalHeight;

				let ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0);

				that.canvas = canvas;

				resolve(that);
			};

			img.src = url;
		}).catch((e) => {
			throw e;
		});
	}

	rotate(deg) {
		let canvas = this.canvas;
		let ctx = canvas.getContext('2d');

		let rotationPointX = canvas.width / 2;
		let rotationPointY = canvas.height / 2;

		var mCanvas = document.createElement('canvas');
		mCanvas.width = canvas.width;
		mCanvas.height = canvas.height;
		var mctx = mCanvas.getContext('2d');

		// Draw your canvas onto the second canvas
		mctx.drawImage(canvas, 0, 0);

		// Clear your main canvas
		ctx.clearRect(0, 0, canvas.width, canvas.height);

		// Rotate the main canvas

		// set the rotation point as center of the canvas
		// (but you can set any rotation point you desire)
		ctx.translate(rotationPointX, rotationPointY);

		// rotate by 90 degrees (==PI/2)
		var radians = (deg * Math.PI) / 180;
		ctx.rotate(radians);

		// Draw the second canvas back to the (now rotated) main canvas:
		ctx.drawImage(mCanvas, -canvas.width / 2, -canvas.height / 2);

		// clean up -- unrotate and untranslate
		ctx.rotate(-radians);
		ctx.translate(-canvas.width / 2, -canvas.height / 2);

		this.canvas = canvas;
	}

	/*

	resizeImage(maxSizeH, maxSizeW) {

		let promise = new Promise(function (resolve, reject) {

			let img = document.createElement('img');
			img.onload = function() {

				let canvas = document.createElement('canvas');
				let ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0);

				let MAX_WIDTH = maxSizeW;
				let MAX_HEIGHT = maxSizeH;
				let width = img.width;
				let height = img.height;

				if (width > height) {
					if (width > MAX_WIDTH) {
						height *= MAX_WIDTH / width;
						width = MAX_WIDTH;
					}
				} else {
					if (height > MAX_HEIGHT) {
						width *= MAX_HEIGHT / height;
						height = MAX_HEIGHT;
					}
				}
				canvas.width = width;
				canvas.height = height;
				let ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0, width, height);
				let dataurl = canvas.toDataURL('image/jpeg', 0.75);

				file.imgSrc = dataurl;

				resolve(file);

			}

			img.src = this.base64;

		});

		return promise;

	}

*/
}

ImageUtils = new ImageUtils();

ImageUtils.MIME_PNG = 'image/png';
ImageUtils.MIME_TIFF = 'image/tiff';
ImageUtils.MIME_JPEG = 'image/jpeg';
ImageUtils.MIME_JGD = 'image/jgd';
ImageUtils.MIME_BMP = 'image/bmp';
ImageUtils.MIME_X_MS_BMP = 'image/x-ms-bmp';
ImageUtils.MIME_GIF = 'image/gif';

export default ImageUtils;
